import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { ChargebackFacade } from '../chargebacks/chargebackFacade';
import { StorageService } from '../../core/storage/storageService';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';
import { CatalogItem } from './catalogItem';
import { Catalog } from './catalog';

@Injectable({
  providedIn: 'root',
})
export class CatalogService {
  //options = { authenticate: true, setRoot: true, updateAuthHeader: false };
  options = { authenticate: true, setRoot: true };

  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  public getCatalogs(merchantId: string): Promise<Partial<Catalog>[]> {
    return this.api
      .apiCallSane(
        '/catalogs',
        'GET',
        this.api.getDefaultHeaders(),
        { merchantId: merchantId },
        null,
        this.options,
      )
      .then((response: Partial<Catalog>[]) =>
        response.map((catalog: Partial<Catalog>) => new Catalog(catalog)),
      );
  }

  public getCatalog(catalogId: string): Promise<Partial<Catalog>> {
    return this.api
      .apiCallSane(
        '/catalog',
        'GET',
        this.api.getDefaultHeaders(),
        { id: catalogId },
        null,
        this.options,
      )
      .then((response: Partial<Catalog>) => new Catalog(response));
  }

  public getCatalogItem(itemId: string): Promise<Partial<CatalogItem>> {
    return this.api
      .apiCallSane(
        '/catalog/item',
        'GET',
        this.api.getDefaultHeaders(),
        { id: itemId },
        null,
        this.options,
      )
      .then((response: Partial<CatalogItem>) => new CatalogItem(response));
  }

  public getAllCatalogItems(catalogId: string): Promise<CatalogItem[]> {
    //let usr = this.storage.getCurrentUser();

    if (!catalogId || catalogId == '') {
      return Promise.resolve([]);
    }

    return this.api
      .apiCallSane(
        '/catalog/items/all',
        'GET',
        this.api.getDefaultHeaders(),
        {
          catalogId: catalogId,
        },
        null,
        this.options,
      )
      .then((response: Partial<CatalogItem>[]) =>
        (response || []).map((item: Partial<CatalogItem>) => new CatalogItem(item)),
      );
  }

  public createCatalog(catalog: Partial<Catalog>): Promise<string> {
    return this.api
      .apiCallSane(
        '/catalog',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        catalog,
        this.options,
      )
      .then((response: string) => {
        return response;
      });
  }

  public saveCatalog(catalog: Partial<Catalog>): Promise<void> {
    return this.api
      .apiCallSane(
        '/catalog',
        'PUT',
        this.api.getDefaultHeaders(),
        null,
        catalog,
        this.options,
      )
      .then(() => {
        return;
      });
  }

  public createCatalogItem(
    item: Partial<CatalogItem>,
  ): Promise<Partial<CatalogItem>> {
    return this.api
      .apiCallSane(
        '/catalog/item',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        {
          catalogId: item.catalogId,
          name: item.name,
          description: item.description,
          price: item.price ? item.price.toString() : '0',
          currencyCode: item.currencyCode,
          isDiscount: item.isDiscount,
        },
        this.options,
      )
      .then((response: Partial<CatalogItem>) => new CatalogItem(response));
    // item.id = "12345";
    // return Promise.resolve(new CatalogItem(item));
  }

  public saveCatalogItem(item: Partial<CatalogItem>): Promise<void> {
    return this.api
      .apiCallSane(
        '/catalog/item',
        'PUT',
        this.api.getDefaultHeaders(),
        null,
        item,
        this.options,
      )
      .then(() => {
        return;
      });
  }

  public archiveCatalog(catalogId: string): Promise<void> {
    return this.api
      .apiCallSane(
        '/catalog',
        'DELETE',
        this.api.getDefaultHeaders(),
        null,
        { id: catalogId },
        this.options,
      )
      .then(() => {
        return;
      });
  }

  public deleteCatalogItem(itemId: string): Promise<void> {
    return this.api
      .apiCallSane(
        '/catalog/item',
        'DELETE',
        this.api.getDefaultHeaders(),
        null,
        { id: itemId },
        this.options,
      )
      .then(() => {
        return;
      });
  }
}
